import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
Vue.config.productionTip = false
import Axios from 'axios'
Axios.defaults.baseURL = "https://bitshopy.herokuapp.com/"  
// Axios.defaults.baseURL = "http://192.168.1.115:3000"

Vue.prototype.$http = Axios;
const token = localStorage.getItem('token'); 
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
